export * from "./simple-date-format.pipe";
export * from "./shared-pipes.module";
export * from "./truncate.pipe";



// WEBPACK FOOTER //
// ./src/app/shared/pipes/index.ts